import HyperCache from '@sailor/hyperCache'
import { getProjectVersionUrl } from '@RootCommon/utils'

export const registerSw = () => {
  // 关闭pwa
  try {
    // @ts-ignore
    const hyperCache = HyperCache.getInstance()
    hyperCache.turnOff()
  } catch (error) {
    console.error('HyperCache 关闭失败', error)
  }

  // try {
  //   console.log(getProjectVersionUrl('main'), 'versionUrl')
  //   // @ts-ignore
  //   HyperCache.register({
  //     // Avatar标识
  //     appKey: 'com.sankuai.sailorfe.b.pc',
  //     // Talos项目标识
  //     appFlag: 'main',
  //     // 自定义更新间隔
  //     verInterval: 5 * 60 * 1000, // 5分钟
  //     // @ts-ignore
  //     versionUrl: getProjectVersionUrl('main'),
  //   })
  // } catch (error) {
  //   console.error('HyperCache 注册 main 失败', error)
  // }

  // try {
  //   console.log(getProjectVersionUrl('finance'), 'versionUrl')
  //   // @ts-ignore
  //   HyperCache.register({
  //     // Avatar标识
  //     appKey: 'com.sankuai.sailorfe.b.pc',
  //     // Talos项目标识
  //     appFlag: 'finance',
  //     // 自定义更新间隔
  //     verInterval: 5 * 60 * 1000, // 5分钟
  //     // @ts-ignore
  //     versionUrl: getProjectVersionUrl('finance'),
  //   })
  // } catch (error) {
  //   console.error('HyperCache 注册 finance 失败', error)
  // }

  // try {
  //   console.log(getProjectVersionUrl('product'), 'versionUrl')
  //   // @ts-ignore
  //   HyperCache.register({
  //     // Avatar标识
  //     appKey: 'com.sankuai.sailorfe.b.pc',
  //     // Talos项目标识
  //     appFlag: 'product',
  //     // 自定义更新间隔
  //     verInterval: 5 * 60 * 1000, // 5分钟
  //     // @ts-ignore
  //     versionUrl: getProjectVersionUrl('product'),
  //   })
  // } catch (error) {
  //   console.error('HyperCache 注册 product 失败', error)
  // }
}
